"use strict";

var _taggedTemplateLiteral = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row nowrap;\n    place-content: flex-start flex-end;\n    align-items: flex-start;\n    cursor: inherit;\n    position: relative;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    background: #eeeeee;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    @media screen and (min-width: 769px) {\n      border-radius: 2px;\n      max-width: 750px;\n      max-height: 500px;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n    inset: 0px;\n    display: flex;\n    -webkit-box-pack: center;\n    justify-content: center;\n    position: fixed;\n    background-color: rgba(47, 53, 62, 0.86);\n    z-index: 11999;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODAL_STYLE = void 0;

var css_1 = require("@emotion/css");

exports.MODAL_STYLE = {
  overlay: (0, css_1.css)(_templateObject()),
  content: (0, css_1.css)(_templateObject2()),
  header: (0, css_1.css)(_templateObject3())
};